<!--
 * @Description: 详情页操作日志通用组件
 * @Author: mdb
 * @Date: 2022-07-22 11:13:40
 * @LastEditTime: 2023-03-08 10:29:08
 * @LastEditors: cxh
-->
<template>
  <cos-table ref="tableRef" serial :columns="columns" v-model:search="queryForm" :tableId="tableId" @fetch="getList" />
</template>

<script setup lang="ts">
import { ref, computed, reactive } from 'vue'
import request from '@/utils/request'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps({
  appId: {
    type: String,
    required: true,
    validator(value: string) {
      return ['cos_fbu', 'cos_ofbu', 'cos_lbu', 'cos_zbu'].includes(value)
    }
  },
  resourceId: {
    type: String,
    required: true
  },
  tableId: {
    type: String,
    required: true
  }
})

const baseEnum: { [key: string]: string } = {
  cos_fbu: '/fbu',
  cos_ofbu: '/ofbu',
  cos_lbu: '/lbu',
  cos_zbu: '/zbu'
}

const queryForm = reactive({ resourceId: props.resourceId })
const columns = computed(() => [
  { title: t('common.operator'), dataIndex: 'createByName', width: 150 },
  { title: t('common.operatorDate'), dataIndex: 'createTime', width: 240 },
  { title: t('common.operationType'), dataIndex: 'operateType', width: 150 },
  { title: t('common.operatorActivity'), dataIndex: 'operateDesc', width: 350 }
])
const getList = (queryForm: object, callBack: (res: any) => void) => {
  request.post(`${baseEnum[props.appId]}/api/operate/log/page/list`, queryForm).then((res) => {
    callBack(res)
  })
}
const tableRef = ref()
const fetch = () => {
  tableRef.value?.fetch()
}
defineExpose({ fetch })
</script>
<script lang="ts">
export default { name: 'TabsOperationLog' }
</script>

<style scoped></style>
